import { render, staticRenderFns } from "./cancellationsuccess.vue?vue&type=template&id=6156b7ca&scoped=true"
import script from "./cancellationsuccess.vue?vue&type=script&lang=js"
export * from "./cancellationsuccess.vue?vue&type=script&lang=js"
import style0 from "./cancellationsuccess.vue?vue&type=style&index=0&id=6156b7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156b7ca",
  null
  
)

export default component.exports